(() => {
  const rank = (a, available) => {
    const scores = {ha:0,charcoal:0,eudermic:0,phyto_serum:0,phyto_cream:0};
    const add = (values) => Object.entries(values).forEach(([key,n]) => scores[key]+=n);
    if(a[0]==='dry') add({ha:4,eudermic:3,phyto_cream:2});
    if(['mixed','oily'].includes(a[0])) add({charcoal:4,eudermic:2});
    if(['balanced','unknown'].includes(a[0])) add({ha:2});
    if(a[1]==='hydration') add({ha:7,eudermic:2,phyto_cream:2});
    if(a[1]==='glow') add({phyto_serum:7,phyto_cream:6});
    if(a[1]==='even') add({phyto_cream:6,phyto_serum:4,charcoal:2});
    if(a[1]==='elasticity') add({eudermic:7,phyto_cream:5,ha:2});
    if(a[3]==='light') add({ha:4,charcoal:4,phyto_serum:4});
    if(a[3]==='cream') add({eudermic:5,phyto_cream:5});
    const sensitive=a[2]!=='rarely';
    const eligible=Object.keys(scores).filter(k=>available.includes(k)&&(!sensitive||['ha','charcoal'].includes(k)));
    eligible.sort((a,b)=>scores[b]-scores[a]);
    if(!eligible.length)return [];
    const first=eligible[0];
    const isCream=k=>['eudermic','phyto_cream'].includes(k);
    const isPhyto=k=>k.startsWith('phyto_')||k==='milk';
    const complementary=eligible.filter(k=>k!==first&&isCream(k)!==isCream(first));
    const complement=complementary.find(k=>isPhyto(k)!==isPhyto(first))||complementary[0];
    const cleanser=sensitive?'clean':(['dry','balanced'].includes(a[0])?'milk':'clean');
    return [first,complement,available.includes(cleanser)?cleanser:(available.includes('clean')?'clean':null)].filter(Boolean);
  };
  const init = () => document.querySelectorAll('[data-ritual-quiz]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const form=root.querySelector('form'), start=root.querySelector('[data-start]'), panels=[...root.querySelectorAll('[data-step]')], next=root.querySelector('[data-next]'), back=root.querySelector('[data-back]'), result=root.querySelector('[data-result]'), copy=JSON.parse(root.querySelector('[data-copy]').textContent);
    let step=0, ritualItems=[], adding=false;
    const cartPanel=root.querySelector('[data-ritual-cart]'), addButton=root.querySelector('[data-add-ritual]'), cartStatus=root.querySelector('[data-cart-status]'), checkCart=root.querySelector('[data-check-cart]');
    const resetCart=()=>{ritualItems=[];cartPanel.hidden=true;cartStatus.textContent='';checkCart.hidden=true;addButton.disabled=false;addButton.textContent=copy.cart_add;};
    addButton.addEventListener('click',async()=>{
      if(adding||!ritualItems.length)return;
      adding=true;addButton.disabled=true;root.querySelector('[data-restart]').disabled=true;
      addButton.textContent=copy.cart_adding;cartStatus.textContent=copy.cart_adding;checkCart.hidden=true;
      try{
        const response=await fetch(root.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:ritualItems}),credentials:'same-origin'});
        const data=await response.json();
        if(!response.ok||!Array.isArray(data.items)||!ritualItems.every(item=>data.items.some(line=>String(line.variant_id||line.id)===String(item.id))))throw new Error('cart_add_failed');
        cartStatus.textContent=copy.cart_added;addButton.textContent=copy.cart_added;
        window.location.assign(root.dataset.cartUrl);
      }catch(error){
        cartStatus.textContent=copy.cart_error;checkCart.hidden=false;addButton.textContent=copy.cart_add;
      }finally{
        adding=false;root.querySelector('[data-restart]').disabled=false;
      }
    });
    const show=()=>{
      panels.forEach((p,i)=>p.hidden=i!==step);
      back.hidden=step===0;
      next.textContent=step===3?copy.finish:copy.next;
      next.disabled=!form.querySelector(`input[name=q${step}]:checked`);
      root.querySelector('[data-progress]').textContent=`${copy.step} ${step+1} ${copy.of} 4`;
      root.querySelector('progress').value=step+1;
      panels[step].querySelector('legend').focus({preventScroll:true});
    };
    start.hidden=false;
    start.addEventListener('click',()=>{start.hidden=true;form.hidden=false;show();});
    form.addEventListener('change',()=>{next.disabled=!form.querySelector(`input[name=q${step}]:checked`);});
    back.addEventListener('click',()=>{if(step>0){step--;show();}});
    form.addEventListener('submit',e=>{
      e.preventDefault();
      if(!form.querySelector(`input[name=q${step}]:checked`))return;
      if(step<3){step++;show();return;}
      const selected=[0,1,2,3].map(i=>form.querySelector(`input[name=q${i}]:checked`));
      if(selected.some(x=>!x))return;
      const answers=selected.map(x=>x.value);
      const available=[...root.querySelectorAll('template[data-product]')].map(t=>t.dataset.product);
      const products=rank(answers,available),cards=root.querySelector('[data-cards]');
      cards.replaceChildren();
      resetCart();
      const productTemplates=products.map(key=>root.querySelector(`template[data-product="${key}"]`));
      if(productTemplates.length&&productTemplates.every(t=>/^\d+$/.test(t.dataset.variantId)&&Number.isFinite(Number(t.dataset.price)))){
        ritualItems=productTemplates.map(t=>({id:t.dataset.variantId,quantity:1}));
        const total=productTemplates.reduce((sum,t)=>sum+Number(t.dataset.price),0);
        root.querySelector('[data-ritual-total]').textContent=new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency}).format(total/100);
        cartPanel.hidden=false;
      }
      products.forEach((key,i)=>{const fragment=root.querySelector(`template[data-product="${key}"]`).content.cloneNode(true);fragment.querySelector('.of-quiz__role').textContent=i===0?copy.primary:copy.extra;fragment.querySelector('.of-quiz__step').textContent=copy[['clean','milk'].includes(key)?'step_clean':(['eudermic','phyto_cream'].includes(key)?'step_cream':'step_serum')];cards.append(fragment);});
      const why=root.querySelector('[data-why]');why.replaceChildren();
      ['skin_'+answers[0],'goal_'+answers[1],'texture_'+answers[3]].forEach(key=>{const li=document.createElement('li');li.textContent=copy[key];why.append(li);});
      const phyto=k=>k.startsWith('phyto_')||k==='milk';
      root.querySelector('[data-pairing]').textContent=copy[products.some(phyto)&&products.some(k=>!phyto(k))?'pairing_mixed':'limited'];
      root.querySelector('[data-summary]').textContent=copy.summary+': '+selected.map(x=>x.nextElementSibling.textContent.trim()).join(' · ');
      root.querySelector('[data-sensitive]').hidden=answers[2]==='rarely';
      root.querySelector('[data-empty]').hidden=products.length>0;
      form.hidden=true;result.hidden=false;result.querySelector('h3').focus();
    });
    root.querySelector('[data-restart]').addEventListener('click',()=>{if(adding)return;resetCart();form.reset();step=0;result.hidden=true;form.hidden=false;root.querySelector('[data-cards]').replaceChildren();show();});
  });
  if(typeof module!=='undefined'&&module.exports)module.exports=rank;
  if(typeof document!=='undefined'){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',init);}
})();

